import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const ADPIntegration = BaseIntegration.extend({
  integrationType: z.literal('ADP'),
  clientIdSecretReference: SecretReference.optional(),
  clientSecretSecretReference: SecretReference.optional(),
  sslCertSecretReference: SecretReference.optional(),
  keyCertSecretReference: SecretReference.optional(),
  agentMode: z.boolean().optional(),
  agentDateCap: z.string().optional(),
});

export type ADPIntegration = z.infer<typeof ADPIntegration>;
